import { useSelector } from "react-redux"
import { useEffect } from "react"
import { useNavigate } from "react-router"

// import CheckoutForm from "../../components/ecommerce/checkout_form/CheckoutForm"
import Cart from "../../features/ecommerce/cart/cart"
import CheckoutForm from "../../features/ecommerce/checkout/checkout_form"
import companyLogo from "../../../assets/logo.png"

import type { RootState } from "../../../store/store"

const Checkout = () => {

    const navigate = useNavigate()
    const order = useSelector((state: RootState) => state.shopOrder)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    if (!order || order.cart.total === 0) return <></>

    return <>
        <header className='flex mx-auto w-full max-w-4xl justify-center items-center p-8'>
            <img src={companyLogo} className='w-32 h-auto' alt='' />
        </header>
        <div className="max-w-2xl mx-auto pt-2 pb-8 sm:pt-6">
            <div className="px-3 sm:px-6 order-2 sm:order-1 space-y-4">
                {/* TODO Use skeletons for loading state */}
                <div className="gap-4 items-center hidden sm:flex">
                    <button onClick={() => navigate(-1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                        </svg>
                    </button>
                    <h1 className="font-bold text-2xl">Checkout</h1>
                </div>
                <Cart />
                <CheckoutForm />
            </div>
        </div>
    </>
}

export default Checkout